import React from 'react'
import AnnotatedWord from './AnnotatedWord'
import { withNamespaces } from 'react-i18next'

const AnnotatedText = props => {
  const { t, text, annotations } = props

  if (!annotations) return <div>{t("Your text hasn't annotations")}</div>
  let sortedAnnotations = annotations.sort(
    (a, b) => parseInt(a.start_offset) - parseInt(b.start_offset)
  )
  let children = []
  let parsedIndex = 0
  let startIndex = null
  let wordAnnotations = []
  let element = null
  for (let i = 0; i < sortedAnnotations.length; i++) {
    if (startIndex !== parseInt(sortedAnnotations[i].start_offset)) {
      wordAnnotations = []
      children.push(
        text.substring(parsedIndex, parseInt(sortedAnnotations[i].start_offset))
      )
      wordAnnotations.push(sortedAnnotations[i])
      element = (
        <AnnotatedWord
          key={i}
          word={text.substring(
            parseInt(sortedAnnotations[i].start_offset),
            parseInt(sortedAnnotations[i].end_offset) + 1
          )}
          annotations={wordAnnotations}
        />
      )
      startIndex = parseInt(sortedAnnotations[i].start_offset)
    } else {
      wordAnnotations.push(sortedAnnotations[i])
      element = (
        <AnnotatedWord
          key={i}
          word={text.substring(
            parseInt(sortedAnnotations[i].start_offset),
            parseInt(sortedAnnotations[i].end_offset) + 1
          )}
          annotations={wordAnnotations}
        />
      )
      children.pop()
    }

    children.push(element)
    parsedIndex = parseInt(sortedAnnotations[i].end_offset) + 1
  }
  children.push(text.substring(parsedIndex))

  return <div className="annotated-text">{children}</div>
}

export default withNamespaces()(AnnotatedText)
